<template>
  <div>
    <modal-layout-top :title="title" />
    <div class="slider-modal">
      <div class="filter-wrapper">
        <div class="columns is-multiline">
          <template v-for="meta in filterMeta">
            <div v-if="meta.fieldId === null" class="column is-half" :key="meta.fieldId"></div>

            <div v-else class="column" :class="[ meta.type === 'multi-select' ? 'is-half' : 'is-half' ]" :key="meta.fieldId">

              <label class="label" v-if="meta.type !== 'bool'">{{ meta.label }}</label>

              <input v-if="meta.type === 'string'" class="input" type="text" :placeholder="meta.label" v-model.lazy="$store.state[dataType].all.filter[meta.fieldId]" v-debounce="debounceDelay">

              <input v-else-if="meta.type === 'date'" class="input" type="date" :placeholder="meta.label" v-model.lazy="$store.state[dataType].all.filter[meta.fieldId]" v-debounce="debounceDelay">

              <select v-else-if="meta.type === 'select'" class="input" v-model="$store.state[dataType].all.filter[meta.fieldId]">
                <option :value="null">Alla</option>
                <option v-for="option in meta.options" :key="option.key" :value="option.key">{{ option.value }}</option>
              </select>

              <template v-else-if="meta.type === 'bool'">
                <template v-if="meta.fieldId === 'showAll'">
                  <label class="label active-switch">&nbsp;</label>
                  <input :id="'id-' + meta.fieldId" type="checkbox" :name="meta.fieldId" v-model="$store.state[dataType].all.filter[meta.fieldId]" class="switch is-rounded active-switch">
                  <label :for="'id-' + meta.fieldId" class="label active-switch show-all"> {{ $store.state[dataType].all.filter[meta.fieldId] ? 'Alla' : 'Aktiva' }}</label>
                </template>
                <template v-else>
                  <label class="label active-switch">&nbsp;</label>
                  <input :id="'id-' + meta.fieldId" type="checkbox" :name="meta.fieldId" v-model="$store.state[dataType].all.filter[meta.fieldId]" class="switch is-rounded active-switch">
                  <label :for="'id-' + meta.fieldId" class="label active-switch">{{ meta.label }}</label>
                </template>
              </template>

              <template v-else-if="meta.type === 'multi-select'">
                <multi-select
                  :options="meta.options"
                  :selected-options="$store.state[dataType].all.filter[meta.fieldId]"
                  :placeholder="meta.placeholder"
                  @select="onMultiSelect($event, meta.fieldId)">
                </multi-select>
              </template>

              <template v-else-if="meta.type === 'model-list-select'">
                <model-list-select
                  :list="meta.options"
                  v-model="$store.state[dataType].all.filter[meta.fieldId]"
                  :option-value="'value'"
                  :option-text="'text'"
                  :placeholder="meta.placeholder">
                </model-list-select>
              </template>

            </div>
          </template>
          <div class="column is-one-fifth" >
            <label class="label">&nbsp;</label>
            <button class="button" :class="{ 'is-primary': filterChanged }" @click="resetFilter" v-if="filterMeta.length > 0">
              <span class="icon is-small">
                <i class="fal fa-undo"></i>
              </span>
              <span>Återställ</span>
            </button>
          </div>
        </div>
      </div>
      <div class="has-text-centered hit-box" @click="closePanel()">
        {{ $store.state[dataType].all.meta.totalItems }} {{ getTotalItemsWord() }}
      </div>
    </div>
  </div>
</template>

<script>

import ModalLayoutTop from '@/components/modals/ModalLayoutTop'
import { ModelListSelect } from 'vue-search-select'
import { MultiSelect } from '@/components/actions/MultiSelect'

export default {
  components: {
    ModalLayoutTop,
    MultiSelect,
    ModelListSelect
  },
  props: {
    dataType: {
      type: String,
      required: true
    },
    resetFilterCallback: {
      type: Function,
      required: false
    },
    filterMeta: Array
  },
  data () {
    return {
      title: 'Filter',
      filterChanged: false,
      debounceDelay: process.env.DEBOUNCE_DELAY
    }
  },
  methods: {
    onMultiSelect (item, fieldId) {
      this.$store.state[this.dataType].all.filter[fieldId] = item
    },

    getTotalItemsWord () {
      if (this.$store.state[this.dataType].all.meta.totalItems === 1) {
        return 'träff'
      } else {
        return 'träffar'
      }
    },

    resetFilter () {
      this.$store.dispatch(this.dataType + '/resetFilter')
    },

    closePanel () {
      this.$emit('closePanel')
    },

    setFilterChanged () {
      this.filterChanged = this.$store.getters[this.dataType + '/isFilterChanged'](this.$route)
    }
  },

  mounted () {
    this.setFilterChanged()

    this.$watch(() => this.$store.state[this.dataType].all.filter, (newValue) => {
      this.setFilterChanged()
    }, { deep: true })
  }
}
</script>

<style lang="scss" scoped>

.hit-box {
  background-color: #eee;
  border-radius: 3px;
  padding: 10px 0;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/modals/FilterModal.vue